import { action, observable, toJS } from 'mobx';
import api from './api';
import { convertCronStructure } from '@app/utils/helpers';

export interface CronProfile {
  id?: number;
  name: string;
  cron: { [key: string]: string };
}

const blankCronProfile: Omit<CronProfile, 'id'> = { cron: { 0: '' }, name: '' };

export default class CronProfilesStore {
  @observable loading = false;
  @observable listCronProfiles: Array<CronProfile> = [];
  private listEditingCronProfiles: Map<number, CronProfile> = new Map();

  @action.bound public async getCronProfiles() {
    this.loading = true;
    const response = await api.getCronProfiles();

    this.listCronProfiles = response.map(item => ({ ...item, cron: convertCronStructure(item.cron) }));
    this.loading = false;
  }

  @action.bound public addBlankProfile() {
    // @ts-ignore

    this.listCronProfiles = [...this.listCronProfiles, blankCronProfile];
  }

  @action.bound public removeCronProfile(item) {
    this.listCronProfiles = this.listCronProfiles.filter(profile => profile.id !== item.id);
  }

  @action.bound public saveBackupItem(item) {
    this.listEditingCronProfiles.set(item.id, toJS(item));
  }

  @action.bound public restoreBackedUpItem(item) {
    if (this.listEditingCronProfiles.has(item.id)) {
      const foundBackup = this.listEditingCronProfiles.get(item.id) as CronProfile;
      this.listEditingCronProfiles.delete(item.id);
      const profile = this.listCronProfiles.find(profile => profile.id === item.id);
      if (profile) {
        Object.assign(profile, foundBackup);
      }
    }
  }
}
